// Function to safely parse a number from a string
function safeParseFloat(value) {
  if (typeof value === 'string') {
    value = value.replace(/[^0-9.]/g, '');
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
}

// Function to format price
function formatPrice(price) {
  // console.log('Formatting price:', price);
  return Number.isInteger(price) ? `$${price.toLocaleString()}` : `$${price.toFixed(2).replace(/\.00$/, '')}`;
}

// Function to update the total price
function updateTotalPrice() {
  const displayPriceElement = document.getElementById('display-price');
  const addOnTotalElement = document.getElementById('add-on-total');
  const totalPriceElement = document.getElementById('total-price');
  const installFeeElement = document.getElementById('install-fee');
  const installFeeWaivedElement = document.getElementById('install-fee-waived');

  if (!displayPriceElement || !addOnTotalElement || !totalPriceElement) {
    console.error('Could not find required price elements');
    return;
  }

  let basePrice = safeParseFloat(displayPriceElement.textContent);
  let addOnPrice = 0;

  // Get all visible and checked inputs with a data-price attribute
  const addOnInputs = document.querySelectorAll(
    '.add-on-product-wrapper:not([style*="display: none"]) input[data-price]:checked, .product-form__input input[type="checkbox"][data-price]:checked, .add-on-product-wrapper:not([style*="display: none"]) input[type="radio"][data-price]:checked'
  );

  // console.log('Number of add-on inputs found:', addOnInputs.length);

  addOnInputs.forEach((input) => {
    const price = safeParseFloat(input.getAttribute('data-price'));
    // console.log('Add-on:', input.value, 'Price:', price);
    addOnPrice += price;
  });

  // Calculate install fee (waived if add-ons >= $2000)
  // Only calculate if install fee is active (element exists)
  let installFee = 0;
  let isInstallFeeWaived = false;

  if (installFeeElement) {
    const installFeeText = installFeeElement.textContent;
    const installFeeMatch = installFeeText.match(/\$?([0-9,]+\.?[0-9]*)/);
    if (installFeeMatch) {
      installFee = parseFloat(installFeeMatch[1].replace(/,/g, ''));
    }
    isInstallFeeWaived = addOnPrice >= 2000;
  }

  const finalInstallFee = isInstallFeeWaived ? 0 : installFee;

  let totalPrice = basePrice + addOnPrice + finalInstallFee;

  // console.log('Base Price:', basePrice);
  // console.log('Add-on Price:', addOnPrice);
  // console.log('Install Fee:', finalInstallFee);
  // console.log('Total Price:', totalPrice);

  // Update HTML elements
  setTimeout(() => {
    // console.log('Updating price elements');
    displayPriceElement.textContent = formatPrice(basePrice);
    addOnTotalElement.textContent = formatPrice(addOnPrice);
    totalPriceElement.textContent = formatPrice(totalPrice);

    // Update install fee display
    if (installFeeElement && installFeeWaivedElement) {
      if (isInstallFeeWaived) {
        installFeeElement.style.display = 'none';
        installFeeWaivedElement.style.display = 'inline';
      } else {
        installFeeElement.style.display = 'inline';
        installFeeWaivedElement.style.display = 'none';
      }
    }

    // Update hidden input field for checkout (only if install fee is active)
    const installFeeInput = document.getElementById('install-fee-input');
    if (installFeeInput && installFeeElement) {
      const installFeeFormatted = formatPrice(installFee);
      installFeeInput.value = isInstallFeeWaived ? '$0.00 (Waived)' : installFeeFormatted;
    }
  }, 100);
}

// Function to handle conditional inputs visibility
function handleConditionalInputs() {
  const addOnWrappers = document.querySelectorAll('.add-on-product-wrapper');

  addOnWrappers.forEach((wrapper, index) => {
    const input = wrapper.querySelector('input');
    if (input) {
      const isVisible = window.getComputedStyle(wrapper).display !== 'none';

      if (isVisible && input.type === 'radio' && !input.checked) {
        // Check if this is the only visible radio in its group
        const name = input.getAttribute('name');
        const visibleRadiosInGroup = document.querySelectorAll(
          `.add-on-product-wrapper:not([style*="display: none"]) input[type="radio"][name="${name}"]`
        );
        if (visibleRadiosInGroup.length === 1) {
          input.checked = true; // Auto-select if it's the only visible option
        }
      } else if (!isVisible && input.checked) {
        input.checked = false; // Uncheck hidden inputs
      }

      // Manage the required attribute based on visibility
      if (isVisible) {
        input.setAttribute('required', 'required');
      } else {
        input.removeAttribute('required');
      }
    }
  });

  updateTotalPrice();
}

// Function to handle vehicle selection changes
function handleVehicleChange() {
  const vehicleSelector = document.querySelector('.disclosure__button span[data-label="Models"]');
  const addOnWrappers = document.querySelectorAll('.add-on-product-wrapper');

  if (vehicleSelector) {
    const selectedVehicle = vehicleSelector.textContent.trim();

    addOnWrappers.forEach((wrapper, index) => {
      const input = wrapper.querySelector('input');
      if (input) {
        const compatibleVehicles = input.getAttribute('data-compatible-vehicles');

        // Check if the add-on is compatible with the selected vehicle
        const isCompatible = compatibleVehicles && compatibleVehicles.includes(selectedVehicle);

        if (isCompatible) {
          wrapper.style.display = 'block';
        } else {
          wrapper.style.display = 'none';
          input.checked = false;
        }
      }
    });
  }

  handleConditionalInputs();
}

// Function to get the current variant ID from the URL
function getCurrentVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

// Function to initialize all price updates and observers
function initializePriceUpdates() {
  // Listen for checkbox and radio button changes
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="checkbox"][data-price], input[type="radio"][data-price]')) {
      // console.log('Input changed:', event.target.value, 'Checked:', event.target.checked);
      updateTotalPrice();
    }
  });

  // Listen for vehicle selection changes
  const vehicleSelector = document.querySelector('.disclosure__button[aria-controls="vehicle-model-list"]');
  if (vehicleSelector) {
    vehicleSelector.addEventListener('click', () => {
      setTimeout(handleVehicleChange, 100); // Short delay to ensure the selection has updated
    });
  }

  // Listen for changes that might affect conditional inputs
  const configOptions = document.querySelectorAll('.product-form__input');
  configOptions.forEach((option) => {
    option.addEventListener('change', handleConditionalInputs);
  });

  // Observe visibility changes
  const visibilityObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        handleConditionalInputs();
      }
    });
  });

  const addOnContainer = document.getElementById('add-on-products');
  if (addOnContainer) {
    visibilityObserver.observe(addOnContainer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style'],
    });
  }

  // Initialize the URL observer
  let currentVariantId = getCurrentVariantId();
  const urlObserver = new MutationObserver(() => {
    const newVariantId = getCurrentVariantId();
    if (newVariantId !== currentVariantId) {
      // console.log('Variant changed from', currentVariantId, 'to', newVariantId);
      currentVariantId = newVariantId;
      // Wait a short moment for any other scripts to update prices
      setTimeout(() => {
        // console.log('Updating prices after variant change');
        updateTotalPrice();
      }, 1000);
    }
  });

  urlObserver.observe(document.body, { subtree: true, childList: true });

  // Initial setup
  handleVehicleChange();
  updateTotalPrice();
}

// Run the initialization when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePriceUpdates);
} else {
  initializePriceUpdates();
}

document.addEventListener('price:update', (event) => {
  // console.log('Price update event received:', event.detail);
  updateTotalPrice();
});
